import * as React from 'react';
import { FC } from 'react';

import { ISanityTextNode } from '@rbi-ctg/menu';
import LoadingAnimation from 'components/loading-animation';
import { ResponsiveCarousel } from 'components/responsive-carousel';

import { QuestsTitle, StyledQuestCard } from './loyalty-quests-widget.styled';
import { useQuests } from './use-quests';

export const LoyaltyQuestsWidget: FC<{ title?: ISanityTextNode }> = ({ title }) => {
  const { data: quests, loading } = useQuests();

  if (loading) {
    return <LoadingAnimation />;
  }

  return (
    <section>
      {title?.locale && <QuestsTitle>{title?.locale}</QuestsTitle>}
      <ResponsiveCarousel>
        {quests.map((quest, idx) => (
          <StyledQuestCard
            $fadeDelayMultiplier={idx}
            quest={quest}
            key={quest?.title?.locale || idx}
          />
        ))}
      </ResponsiveCarousel>
    </section>
  );
};
